
<div class="padding16">
    <app-home-cameras [nameTextColor]="'#666666'" [flatButton]="true"></app-home-cameras>
</div>
<app-plus-button *ngIf="systems.activeSystemHelper.can.add.cameras()" (plusClicked)="addCamera()" [showLimiter]="true" [currentCount]="cameraCount" [maxLimit]="cameraLimit"></app-plus-button>